// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClassDataList_wrapper__1IPHo","groupCheck":"ClassDataList_groupCheck__lNsJV"};